@if (booking) {
<div class="dialog-shell">
  <div class="dialog-header">
    <div>
      <h5 class="dialog-title">Booking Details</h5>
      <p class="dialog-subtitle">{{ getServiceNames() }}</p>
    </div>
    <div class="flex align-items-center gap-2">
      <p-tag [value]="getStatusLabel(booking.status)" [severity]="getStatusSeverity(booking.status)"></p-tag>
      <p-button icon="pi pi-times" [text]="true" severity="secondary" (onClick)="close()"></p-button>
    </div>
  </div>

  <div class="dialog-body">
    <div class="grid">
      <div class="col-12 md:col-6 mb-3">
        <h6 class="m-0 mb-2 font-medium text-600">Patient</h6>
        <p class="m-0 font-semibold">{{ booking.patient.value || '-' }}</p>
      </div>
      <div class="col-12 md:col-6 mb-3">
        <h6 class="m-0 mb-2 font-medium text-600">Doctor</h6>
        <p class="m-0 font-semibold">{{ booking.doctor?.value || 'Not assigned' }}</p>
      </div>
    </div>
    <div class="grid">
      <div class="col-12 md:col-6 mb-3">
        <h6 class="m-0 mb-2 font-medium text-600">Type</h6>
        <p class="m-0 font-semibold">{{ booking.type?.value || '-' }}</p>
      </div>
      <div class="col-12 md:col-6 mb-3">
        <h6 class="m-0 mb-2 font-medium text-600">Services</h6>
        <p class="m-0 font-semibold">{{ getServiceNames() }}</p>
      </div>
      <div class="col-12 md:col-6 mb-3">
        <h6 class="m-0 mb-2 font-medium text-600">Schedule</h6>
        <p class="m-0 font-semibold">{{ booking.appointment_date | date:'medium' }}</p>
      </div>
    </div>
    <div class="mb-3">
      <h6 class="m-0 mb-2 font-medium text-600">Location</h6>
      <p class="m-0 font-semibold">{{ getBookingLocation() }}</p>
    </div>
    <div class="grid">
      <div class="col-12 md:col-6 mb-3">
        <h6 class="m-0 mb-2 font-medium text-600">Pricing</h6>
        <p class="m-0 mb-1"><strong>Final:</strong> {{ (booking.final_price ?? 0) | currency }}</p>
        <p class="m-0"><strong>Discount:</strong> {{ booking.discount ?? '-' }}</p>
      </div>
      <div class="col-12 md:col-6 mb-3">
        <h6 class="m-0 mb-2 font-medium text-600">Notes</h6>
        <p class="m-0">{{ booking.notes || '-' }}</p>
      </div>
    </div>
    <div class="grid border-top-1 border-200 pt-3">
      <div class="col-4">
        <h6 class="m-0 mb-2 font-medium text-600">Weight</h6>
        <p class="m-0">{{ booking.weight ?? '-' }}</p>
      </div>
      <div class="col-4">
        <h6 class="m-0 mb-2 font-medium text-600">Height</h6>
        <p class="m-0">{{ booking.height ?? '-' }}</p>
      </div>
      <div class="col-4">
        <h6 class="m-0 mb-2 font-medium text-600">Temperature</h6>
        <p class="m-0">{{ booking.temperature ?? '-' }}</p>
      </div>
    </div>
  </div>

  <div class="dialog-footer">
    <button pButton label="Close" class="p-button-outlined" (click)="close()"></button>
  </div>
</div>
}
